import type { InputType } from '@ui-component-library/components/_deprecated/Input/Input.types';

export const sanitizeInputValue = (value: string, type: InputType) => {
  if (type === 'phone' || type === 'identityNumber') {
    return value.replace(/\D/g, '');
  }
  return value;
};
